import React, { Fragment } from 'react';
import { withStyles } from '@material-ui/core/styles';
import MaterialButton from '@material-ui/core/Button';
import classNames from 'classnames';

const styles = () => ({
  button: {
    padding: '23px 35px',
    borderRadius: '10px',
    fontSize: '18px',
    lineHeight: '18px',
    textTransform: 'uppercase',
    fontFamily: 'Montserrat',
    fontWeight: 600
  },
  blogBreadcrumb: {
    backgroundColor: 'transparent',
    padding: '12px 25px',
    fontSize: '16px',
    lineHeight: '16px',
    textTransform: 'uppercase',
    color: '#ffffff',
    boxShadow: 'none',
    borderRadius: '10px',
    fontFamily: 'Montserrat',
    '&:hover': {
      backgroundColor: '#ffffff',
      color: '#23a567'
    },
    '&.active': {
      backgroundColor: '#ffffff',
      color: '#23a567'
    }
  },
  buttonGreen: {
    background: '#23a567',
    color: '#ffffff',
    '&:hover': {
      background: '#f96a32'
    }
  },
  buttonBlock: {
    display: 'block',
    width: '100%'
  }
});

const Button = ({
  color,
  children,
  classes,
  block,
  className,
  type,
  blogBreadcrumb,
  onClick
}) => {

  const buttonClasses = classNames(className, {
    [classes.button]: !blogBreadcrumb,
    [classes.blogBreadcrumb]: blogBreadcrumb,
    [classes.buttonGreen]: color === 'green',
    [classes.buttonBlock]: block
  });
  // debugger;
  return (
    <Fragment>
      <MaterialButton
        variant="contained"
        className={buttonClasses}
        type={type !== null ? type : 'button'}
        onClick={onClick}>
        {children}
      </MaterialButton>
    </Fragment>
  );
};

export default withStyles(styles)(Button);